import { PlateAddress } from "../../Model/PlateAddress";

export enum EPlateAddressAction {
  FETCH_PLATEADDRESSES_PENDING = "FETCH_PLATEADDRESSES_PENDING",
  FETCH_PLATEADDRESSES_SUCCESS = "FETCH_PLATEADDRESSES_SUCCESS",
  FETCH_PLATEADDRESSES_ERROR = "FETCH_PLATEADDRESSES_ERROR",
  UPDATE_PLATEADDRESSES = "UPDATE_PLATEADDRESSES",
  SET_SELECTED_PLATEADDRESSES = "SET_SELECTED_PLATEADDRESSES",
}

export interface PlateAddressAction {
  type: EPlateAddressAction;
  plateAddresses?: PlateAddress[];
  updatedPlateAddresses?: PlateAddress[];
  error?: any;
}

export function fetchPlateAddressesPending(): PlateAddressAction {
  return {
    type: EPlateAddressAction.FETCH_PLATEADDRESSES_PENDING,
  };
}

export function fetchPlateAddressesSuccess(plateAddresses: PlateAddress[]): PlateAddressAction {
  return {
    type: EPlateAddressAction.FETCH_PLATEADDRESSES_SUCCESS,
    plateAddresses: plateAddresses,
  };
}

export function updatePlateAddresses(plateAddresses: PlateAddress[]) {
  return {
    type: EPlateAddressAction.UPDATE_PLATEADDRESSES,
    updatedPlateAddresses: plateAddresses,
  };
}

export function fetchPlateAddressesError(error: any) {
  return {
    type: EPlateAddressAction.FETCH_PLATEADDRESSES_ERROR,
    error: error,
  };
}
